import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import InputCustom from "../../../../../../components/InputCustom";
import Loading from "../../../../../../core/common/Loading";
import { formatDateTimeBR } from "../../../../../../helpers/format";
import api from "../../../../../../services/api";
import { IOperacoesPatioGuichesMovimentacao } from "../../types/types";
import * as Yup from "yup";
import { FrontendNotification, NotificationType } from "../../../../../../shared/Notification";
import { useAuth } from "../../../../../../hooks/AuthenticateContext";

interface FormValues {
  abertura_valor_caixa: number | string;
  abertura_data_hora: string;
}

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  selectedRow?: IOperacoesPatioGuichesMovimentacao;
  onConfirm: () => void;
  onClose: () => void;
  guicheId?: string | number | null;
}

const Form: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { user } = useAuth();

  const handleSubmit = useCallback(
    async (values: FormValues, row?: IOperacoesPatioGuichesMovimentacao) => {
      try {
        setLoading(true);

        setLoading(true);

        const guicheId = props.guicheId;

        const body = {
          id_operacao_patio_guiche_movimentacao: row?.id_operacao_patio_guiche_movimentacao,
          id_operacao_patio_guiche: guicheId,
          abertura_valor_caixa: values.abertura_valor_caixa,
          id_usuario_historico: user?.id,
          ativo: true,
        };

        if (props.isEdit) {
          await api.post("/editar/operacaoPatioGuichesMovimentacao", body);
        } else {
          await api.post("/cadastrar/operacaoPatioGuichesMovimentacao", body);
        }

        setLoading(false);
        props.onConfirm();
      } catch (error: any) {
        setLoading(false);
        const message = error?.response?.data?.message || error?.response?.data?.error_msg;
        if (message) {
          FrontendNotification(message, NotificationType.ERROR);
        }
      }
    },
    [props.isEdit, props.onConfirm, user]
  );

  const formik = useFormik<FormValues>({
    initialValues: {
      abertura_valor_caixa: "",
      abertura_data_hora: formatDateTimeBR(new Date()),
    },
    validationSchema: Yup.object({
      abertura_valor_caixa: Yup.number().min(200, "O valor mínimo é R$ 200,00").required("Campo obrigatório"),
    }),
    onSubmit: (values) => {
      handleSubmit(values, props.selectedRow);
    },
  });

  const onLoadFormValues = useCallback(
    (row: IOperacoesPatioGuichesMovimentacao) => {
      if (row) {
        formik.setFieldValue("abertura_valor_caixa", row.abertura_valor_caixa);
        formik.setFieldValue("abertura_data_hora", formatDateTimeBR(row.abertura_data_hora));
      }
    },
    [formik]
  );

  useEffect(() => {
    if (props.selectedRow) {
      onLoadFormValues(props.selectedRow);
    }
  }, [props.selectedRow, onLoadFormValues]);

  return (
    <>
      <Loading loading={loading} skeletonFields={2} skeletonColumns={1} />
      <div className="overflow-y-scroll max-w-full max-h-[550px] p-5">
        <div className="grid grid-cols-1 gap-4">
          <InputCustom
            title="Data de Abertura"
            name="abertura_data_hora"
            value={formik.values.abertura_data_hora}
            disabled={true}
            onChange={() => {}}
            placeholder=""
          />
          <InputCustom
            title="Valor do Caixa Abertura"
            name="abertura_valor_caixa"
            placeholder="Digite o valor"
            onChange={(value) => {
              const numericValue = value.replace(/[^0-9]/g, "");
              if (!numericValue) {
                formik.setFieldValue("abertura_valor_caixa", "");
                return;
              }
              const floatValue = parseFloat(numericValue) / 100;
              formik.setFieldValue("abertura_valor_caixa", floatValue);
            }}
            value={
              formik.values.abertura_valor_caixa !== "" && formik.values.abertura_valor_caixa !== undefined
                ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
                    Number(formik.values.abertura_valor_caixa)
                  )
                : ""
            }
            error={formik.errors.abertura_valor_caixa}
            touched={formik.touched.abertura_valor_caixa}
            disabled={props.isView}
          />
        </div>
      </div>
      <div className="w-full h-14 flex items-center justify-end bg-[#FFFFFF] shadow-xl">
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#F9FAFA] text-sm text-[#000000] font-bold rounded-full mr-2"
          style={{ border: "1px solid #DBDEDF" }}
          onClick={props.onClose}
          id="btnCancel"
        >
          Cancelar
        </button>
        {!props.isView && (
          <button
            type="button"
            className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#0A4984] text-sm text-[#fff] font-bold rounded-full mr-2"
            onClick={() => formik.handleSubmit()}
            id="btnSave"
          >
            Salvar
          </button>
        )}
      </div>
    </>
  );
};

export default Form;
